import {appConfigDev, appConfigProd, azureAdminClientProd, IEnvironment} from './model';
import versions from '../_versions';

export const environment = <IEnvironment>{
    appTitle: "ORGA App Admin Client",
    production: true,
    debug: false,
    appConfig: appConfigProd,
    azureAd: azureAdminClientProd,

    loginRoute: '/login',
    signalRBaseUrl: appConfigDev.wsEndpoint,
    version: versions.version,
    hankoUrl: 'https://auth.orgarena.de',
};

